import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useNotification } from '../context/NotificationContext';

const Notification = () => {
    const { notification, clearNotification } = useNotification();

    if (!notification) return null;

    return (
        <Snackbar
            open={!!notification}
            autoHideDuration={6000}
            onClose={clearNotification}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={clearNotification}
                severity={notification.type}
                sx={{ width: '100%' }}
            >
                {notification.message}
            </Alert>
        </Snackbar>
    );
};

export default Notification;